/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ReferencedComponent from '../ComponentReference/ReferencedComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
@cc._decorator.disallowMultiple
export default class NodeProperties extends ReferencedComponent
{
    @property()
    public ZIndex: boolean = true;

    @property({ type: cc.Integer, visible: (function(): boolean { return this.ZIndex; }) })
    public ZIndexValue: number = 0;

    protected onLoad(): void
    {
        super.onLoad();

        if (this.ZIndex) { this.node.zIndex = this.ZIndexValue; }
    }
}
